<template>
  <article class="page-academy-collection">
    <div class="collection-container">
      <section class="pt-[32px] top-[0px] z-10 pb-[28px]">
        <a-breadcrumb :separator="separator">
          <a-breadcrumb-item class="text-font-60">
            <nuxt-link to="/academy"> {{ $t('mo-fa-xue-yuan') }} </nuxt-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <nuxt-link> {{ info?.title }}</nuxt-link>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </section>
      <section class="page-academy-content mx-auto">
        <BaseCard
          v-for="item in list"
          :key="item.id"
          :class="[
            'page-academy-content__card mb-[2px]',
            { 'live-item': isLive },
          ]"
          :data="formatCard(item)"
          :link="{
            name: PageKey.ACADEMY_DETAIL,
            params: {
              collection: `${info?.outer_id}-${info?.id}`,
              id: `${info?.id}-${item.id}`,
            },
          }"
        >
          <template #title>
            <template v-if="cardName(item.name).length > 1">
              <span class="main-title font-[600]">
                {{ cardName(item.name)[0] }}
              </span>
              <span class="sub-title"> | {{ cardName(item.name)[1] }} </span>
            </template>
            <template v-else>
              {{ item.name }}
            </template>
          </template>
          <template v-if="isLive" #other>
            <div class="live-time">{{ item.description }}</div>
            <nuxt-link
              class="go-replay w-full flex items-center justify-center cursor-pointer"
              :to="{
                name: PageKey.ACADEMY_DETAIL,
                params: {
                  collection: `${info?.outer_id}-${info?.id}`,
                  id: `${info?.id}-${item.id}`,
                },
              }"
            >
              <iconpark-icon name="play-01" :size="15"></iconpark-icon>
              {{ $t('kan-hui-fang') }}
            </nuxt-link>
          </template>
        </BaseCard>
      </section>
    </div>
  </article>
</template>

<script setup lang="ts">
import { h } from 'vue'
import {
  getHelpCategory,
  getHelpCategoryDoc,
  SEARCH_TYPE,
  type IHelpCategoryDoc,
} from '~/api'
import BaseCard from '~/components/content/baseCard.vue'
import { PageKey } from '~/constants/page'

const cardName = (name: string) => name.split('|')

const route = useRoute()
const { $t } = useNuxtApp()

const bg = computed(() => {
  if (!isChinese()) {
    return undefined
  }
  const link = transformImage(
    getFeUrl('/youyan-platform/png/academy/header-bg.png')
  )
  return `url(${link})`
})

const separator = h('iconpark-icon', { name: 'breadcrumb-separator', size: 10 })

const formatCard = (card: IHelpCategoryDoc) => {
  return {
    title: card.name,
    cover_image_url: card.cover_url,
    ...card,
  }
}

const parsedId = (() => {
  const ids = String(route.params.collection).split('-')
  return +ids[ids.length - 1]
})()

const { data: infos } = useAsyncData(async () => {
  const res = await getHelpCategory({ model_type: SEARCH_TYPE.ACADEMY })
  return res.data
})

const info = computed(() => {
  return infos.value?.find((o) => o.id === parsedId)
})

const isLive = computed(() => {
  return info.value?.title.includes($t('zhi-bo'))
})

const { data: list } = useAsyncData(async () => {
  const res = await getHelpCategoryDoc({ column_id: parsedId })
  return res.data
})
</script>

<style lang="scss" scoped>
.live-time {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-1);
}
.page-academy-collection {
  background-image: v-bind('bg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.collection-container {
  margin: 0 auto;
  width: 1200px;
}
.page-academy-content {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.live-item {
  cursor: initial;
  :deep(.arrow) {
    display: none !important;
  }
  &:hover {
    .go-replay {
      background-color: var(--primary-color);
      color: var(--text-0);
      border-radius: 8px;
    }
  }
}
.go-replay {
  margin-top: 12px;
  height: 42px;
  background-color: var(--back-2);
  color: var(--primary-color);
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  iconpark-icon {
    margin-right: 8px;
  }
}
</style>
